import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import {
    DashboardOutlined,
    FileTextOutlined,
    UserOutlined,
    LogoutOutlined,
} from '@ant-design/icons';

const Sidebar = ({ projectNames }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const userRole = localStorage.getItem('role');
    const [isModalVisible, setIsModalVisible] = React.useState(false);

    const showLogoutModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('userData');
        navigate('/login');
        setIsModalVisible(false);
    };

    const getLinkClass = (path) => {
        return location.pathname === path
            ? 'bg-[#EEEEEE] rounded px-4 py-3 flex items-center space-x-2 font-semibold'
            : 'px-3 py-2 flex items-center space-x-2 font-semibold hover:text-orange-400';
    };

    return (
        <div className="h-screen w-[20%] bg-[#FAFAFA] flex flex-col justify-between p-4 border-r">
            <div>
                {/* Logo */}
                <div className=" mb-6 border-b px-6 py-3">
                    <img src="/logo.png" alt="Logo" className="h-6" />
                </div>

                {/* Navigation */}
                <nav className="flex flex-col gap-2">
                    <Link to="/" className={getLinkClass('/')}>
                        <DashboardOutlined /> <span>Dashboard</span>
                    </Link>

                    <Link to="/daily-log" state={{ projectNames }} className={getLinkClass('/daily-log')}>
                        <FileTextOutlined /> <span>Daily log</span>
                    </Link>

                    {userRole === 'admin' && (
                        <Link to="/Users" className={getLinkClass('/Users')}>
                            <UserOutlined /> <span>Users</span>
                        </Link>
                    )}
                </nav>
            </div>

            {/* Logout */}
            <div className="px-2">
                <button
                    onClick={showLogoutModal}
                    className="flex items-center space-x-2 text-blue-900 hover:text-red-600 font-medium"
                >
                    <LogoutOutlined /> <span>Log out</span>
                </button>
            </div>

            {/* Logout Modal */}
            <Modal
                title="Confirm Logout"
                visible={isModalVisible}
                onOk={handleLogout}
                onCancel={handleCancel}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ danger: true }}
            >
                <p>Are you sure you want to logout?</p>
            </Modal>
        </div>
    );
};

export default Sidebar;